<template>
    <Sidebar collapsible="icon">
        <SidebarHeader class="border-sidebar-border border-b px-3 py-4">
            <SidebarMenu>
                <SidebarMenuItem>
                    <SidebarMenuButton size="lg" as-child>
                        <Link :href="dashboard().url">
                            <span
                                class="bg-sidebar-primary text-sidebar-primary-foreground flex size-8 shrink-0 items-center justify-center rounded-lg"
                                ><Rocket class="size-4" aria-hidden="true"
                            /></span>
                            <span class="grid text-left leading-tight"
                                ><span class="font-semibold">LaunchStation</span
                                ><span class="text-muted-foreground text-xs"
                                    >Organization</span
                                ></span
                            >
                        </Link>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarHeader>
        <SidebarContent>
            <SidebarGroup>
                <SidebarGroupLabel>Workspace</SidebarGroupLabel>
                <SidebarGroupContent>
                    <nav aria-label="Staff navigation">
                        <SidebarMenu>
                            <SidebarMenuItem
                                v-for="item in navigation"
                                :key="item.label"
                            >
                                <SidebarMenuButton
                                    as-child
                                    :is-active="item.active"
                                    :tooltip="item.label"
                                >
                                    <Link
                                        :href="item.url"
                                        :aria-current="
                                            item.active ? 'page' : undefined
                                        "
                                        @click="setOpenMobile(false)"
                                    >
                                        <component
                                            :is="item.icon"
                                            aria-hidden="true"
                                        /><span>{{ item.label }}</span>
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </nav>
                </SidebarGroupContent>
            </SidebarGroup>
        </SidebarContent>
        <SidebarFooter class="border-sidebar-border border-t">
            <div class="px-2 py-2 group-data-[collapsible=icon]:hidden">
                <p class="truncate text-sm font-medium">{{ staff?.name }}</p>
                <p class="text-muted-foreground mt-1 text-xs capitalize">
                    {{ staff?.role }}
                </p>
            </div>
            <SidebarMenu
                ><SidebarMenuItem
                    ><SidebarMenuButton
                        tooltip="Sign out"
                        @click="router.post(logout().url)"
                        ><LogOut aria-hidden="true" /><span
                            >Sign out</span
                        ></SidebarMenuButton
                    ></SidebarMenuItem
                ></SidebarMenu
            >
        </SidebarFooter>
    </Sidebar>
</template>
<script setup lang="ts">
import { Link, router } from '@inertiajs/vue3';
import { LogOut, Rocket } from '@lucide/vue';
import type { Component } from 'vue';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from '@/components/ui/sidebar';
import { useOrg } from '@/composables/useOrg';
import { dashboard, logout } from '@/lib/org/routes';
defineProps<{
    navigation: {
        label: string;
        url: string;
        icon: Component;
        active: boolean;
    }[];
}>();
const { staff } = useOrg();
const { setOpenMobile } = useSidebar();
</script>
